import React from 'react'
import { string, arrayOf } from 'prop-types'
import Sticky from 'react-stickynode'
import styled from 'styled-components'

import ScrollSpyNav from 'components.v2/ScrollSpyNav'
import Text from 'components.v2/Text'

const STICKY_OFFSET = 78 // height of venue header
const SCROLL_OFFSET = 143 // sum of height of venue header and height of sticky category nav

const MenuCategory = ({ categories }) => (
  <Sticky
    top={STICKY_OFFSET}
    bottomBoundary="#sticky-categories-boundary"
    innerZ={1}
  >
    <ScrollSpyNav
      list={categories}
      scrollLinkProps={{ offset: -SCROLL_OFFSET }}
      renderContainer={MenuCategoryContainer}
      renderItem={MenuCategoryItem}
      alwaysShowActive
    />
  </Sticky>
)

MenuCategory.propTypes = {
  categories: arrayOf(string),
}

export default MenuCategory

export const MenuCategoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.colors.white};
  height: 65px;
  width: 100%;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const MenuCategoryItem = styled(Text)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 0 15px;
  height: 65px;
  border-bottom: 2px solid transparent;

  &.active {
    border-bottom-color: ${props => props.theme.colors.whitelabel};
    color: ${props => props.theme.colors.whitelabel} !important;
  }
`
